'use client';

import { usePathname } from 'next/navigation';

type GuardType = 'isAccountClosedRoute';

/**
 * Conditionally renders children based on guard types and conditions.
 * Prevents rendering when specific guard conditions are met.
 * @param guards - Array of guard types that should prevent rendering when conditions are met
 * @param children - The content to render if the guard conditions are not met
 * @returns null if the guard conditions are met, otherwise the children
 */
export const RenderGuard = ({
	guards,
	children,
}: {
	guards?: GuardType[];
	children: React.ReactNode;
}) => {
	const pathname = usePathname();
	const isAccountClosedRoute = pathname?.includes('/account-closed');

	if (guards && guards.includes('isAccountClosedRoute') && isAccountClosedRoute) {
		return null;
	}

	return <>{children}</>;
};
